import {login, logout, getInfo, fastLogin} from '@/api/login'
import {getToken, setToken, removeToken} from '@/utils/auth'
// import defAva from '@/assets/images/profile.jpg'
// @ts-ignore
import defAva from '@/assets/images/avatar.jpeg'
import {getUnreadAmount} from "@/api/system/message";
import useWebSocket from "@/store/modules/webSocket";
import {defineStore} from "pinia/dist/pinia";
import type DictEntity from "@/type/common/DictEntity";
import type {WarnLevel} from "@/type/warn/WarnLevel";
import {getSwitchBySwitchType} from "@/api/system/switch";
import {SwitchTypeEnum} from "@/type/system/Switch";
import {getConfigKey} from "@/api/system/config";

const useUserStore = defineStore(
    'user',
    {
        state: (): {
            token: any;
            name: string;
            avatar: string;
            roles: any[];
            permissions: any[];
            id: any;
            unreadMsgAmount: number;
            projects: DictEntity<number>[];
            warnLevels: WarnLevel[];
            taskCount: number;
            dataFilter: boolean;
            gnssUnit: string
        } => ({
            token: getToken(),
            name: '',
            avatar: '',
            roles: [],
            permissions: [],
            id: '',
            unreadMsgAmount: 0,
            taskCount: 0,
            projects: [],
            warnLevels: [],
            dataFilter: false,
            gnssUnit: 'mm'
        }),
        actions: {
            fastLogin(userInfo: any) {
                const username = userInfo.username.trim()
                const password = userInfo.password
                const code = userInfo.code
                const uuid = userInfo.uuid
                return new Promise((resolve, reject) => {
                    fastLogin(username, password, code, uuid).then(res => {
                        if (res.token) {
                            setToken(res.token)
                            this.token = res.token
                            useWebSocket().connect();
                            resolve()
                        }
                        resolve(res.data)
                    }).catch(error => {
                        reject(error)
                    })
                })
            },
            // 登录
            login(userInfo: any) {
                const username = userInfo.username.trim()
                const password = userInfo.password
                const code = userInfo.code
                const uuid = userInfo.uuid
                const tenantId = userInfo.tenantId
                return new Promise((resolve, reject) => {
                    login(username, password, code, uuid, tenantId).then(res => {
                        setToken(res.token)
                        this.token = res.token
                        useWebSocket().connect();
                        resolve()
                    }).catch(error => {
                        reject(error)
                    })
                })
            },
            // 获取用户信息
            getInfo() {
                return new Promise((resolve, reject) => {
                    getInfo().then(res => {
                        localStorage.setItem('tenantId',res.tenantId);
                        const user = res.user;
                        const avatar = (user.avatar == "" || user.avatar == null) ? defAva : import.meta.env.VITE_APP_BASE_API + user.avatar;
                        if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
                            this.roles = res.roles
                            this.permissions = res.permissions
                        } else {
                            this.roles = ['ROLE_DEFAULT']
                        }
                        this.warnLevels = res.warnLevels
                        this.projects = res.projects || []
                        this.name = user.nickName
                        this.avatar = avatar;
                        this.id = user.userId;
                        resolve(res)
                    }).catch(error => {
                        reject(error)
                    })
                })
            },
            // 退出系统
            logOut() {
                return new Promise((resolve, reject) => {
                    logout(this.token).then(() => {
                        this.token = ''
                        this.roles = []
                        this.permissions = []
                        removeToken()
                        useWebSocket().disconnect();
                        resolve()
                    }).catch(error => {
                        reject(error)
                    })
                })
            },
            // 获取未读消息数量
            getUnreadAmount() {
                return new Promise((resolve, reject) => {
                    getUnreadAmount().then(res => {
                        this.unreadMsgAmount = res.data.unreadCount;
                        this.taskCount = res.data.taskCount;
                        resolve(res)
                    })
                })
            },
            // 获取数据过滤启用状态
            getDataFilter() {
                return new Promise((resolve, reject) => {
                    getSwitchBySwitchType(SwitchTypeEnum.data_filter, {
                        nullDefaultCreate: true
                    }).then(res => {
                        this.dataFilter = res.data.status === 0
                        resolve(res);
                    });
                })
            },
            getGnssUnit() {
                return new Promise((resolve, reject) => {
                    getConfigKey("device.unit.gnss").then(res => {
                        console.log("获取到的config: ", res);
                        let unit = "mm";
                        if (res != null && !!res.msg) {
                            unit = res.msg;
                        }
                        this.gnssUnit = unit;
                        resolve(unit);

                    });
                })
            },
        },
        getters: {
            hasProject: state => {
                return (projectId: number) => !!state.projects.find(item => item.value === projectId)
            },
            isInnerAdmin: state => {
                return !!state.roles.find(role => role === "inner")
            },
            isAdmin: state => {
                return !!state.roles.find(role => role === "inner" || role === "admin")
            }
        }
    })

export default useUserStore
